<nav class="navbar navbar-expand-lg navbar-primary bg-primary">
  <a class="navbar-brand" [routerLink]="['/']"><img src="assets/images/much-smarter-logo.svg"/> Student</a>

  <a class="nav-link" (click)="open(modal)" title="Play Overview"><i class="fa fa-play"></i></a>

  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ms-auto">

      @if (allCourses.length > 0) {
        <li class="nav-item courses-dropdown" #coursesDropdown>
          <i class="fas fa-bars" id="courses-dropdown-toggle" (click)="coursesHidden = !coursesHidden"></i>
          <div class="courses-menu" [ngClass]="{'hidden': coursesHidden}">
            <ul class="course-list">
              @for (course of getActiveCourseList(); track course; let index = $index) {
                <li class="course-item"
                  [ngClass]="{'active': course.id === activeCourse.id}"
                  (click)="selectCourse(course.id)">
                  {{course.title}}
                </li>
              }
              @if (canSwitchCountry()) {
                <li class="course-item" (click)="switchCountry()">(switch to {{getNewCountry() | uppercase}})</li>
              }
            </ul>
          </div>
        </li>
      }

      <!-- <li class="nav-item" *ngIf="!paymentService.status?.premium">
      <a class="nav-link" (click)="open(upgradeModal)">
        <i class="fas fa-star"></i>&nbsp;&nbsp;Upgrade to Premium
      </a>
    </li> -->
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/student/history']">
        <i class="fa fa-chart-pie"></i>&nbsp;&nbsp;History
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/student/profile']">
        <i class="fa fa-user"></i>&nbsp;&nbsp;Profile
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" (click)="logOut()">
        <i class="fa fa-power-off"></i>&nbsp;&nbsp;Log Out
      </a>
    </li>
  </ul>
</div>
</nav>

<ng-template #modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Welcome Video</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-4">
    @if (content) {
      <div class="embed-responsive embed-responsive-16by9">
        <video class="embed-responsive-item" allowfullscreen autoplay>
          <source src="https:{{content.welcomeVideo.file.url}}" type="video/mp4">
        </video>
      </div>
    }
  </div>
</ng-template>

<!-- <ng-template #upgradeModal let-c="close" let-d="dismiss">
<div class="modal-header">
  <h1 class="modal-title" id="modal-title">{{ content.upgradeHeadline }}</h1>
  <button [disabled]="upgrading" type="button" class="close" aria-label="Close" (click)="d('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-4 text-center" *ngIf="!upgrading; else loading">
  <div class="mb-4">
    <markdown [data]="content.upgradeContent"></markdown>
  </div>

  <a class="btn btn-primary" (click)="upgradeToPremium()">Upgrade</a>
</div>
<app-feedback></app-feedback>
</ng-template> -->

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
